export { HOTEL_CARD_MAX_WIDTH, HotelCardMobileComponent, HotelCardMobile } from "./HotelCardMobile";